import type { Messages } from './en';

/** Contenido de la fase 3: minijuegos de la sala recreativa (todos de diseño original). */
export const esArcade: Pick<Messages, 'arcade'> = {
  arcade: {
    title: '🕹️ Recreativos',
    hint: '¡Elige un juego! Con buenas puntuaciones ganas estrellas (unas pocas por juego cada día).',
    play: '▶ Jugar',
    again: '🔁 Otra vez',
    back: '⬅ Juegos',
    score: 'Puntos',
    best: 'Récord',
    over: '¡Fin de la partida!',
    win: '¡Has ganado!',
    earned: (n: number) => `+${n}⭐ conseguidas`,
    capped: 'Ya has ganado hoy las estrellas de este juego. ¡Juega por diversión!',
    tap: 'Toca para empezar',
    games: {
      volleyball: { name: 'Vóley Loco', how: 'Muévete ◀ ▶ debajo de la pelota y pulsa ● para pasarla por encima de la red. ¡Que no caiga!' },
      tennis: { name: 'Raquetazo', how: 'Muévete ◀ ▶ hacia la pelota y pulsa ● cuando te llegue para devolverla.' },
      rhythm: { name: 'Ritmo de Piano', how: 'Toca el carril cuando una nota llegue a la línea. ¡Cada acierto suena!' },
      drawing: { name: 'Cuaderno de Dibujo', how: 'Dibuja con el dedo. Elige colores y pinceles, ¡y compártelo en PixelBook!' },
      racing: { name: 'Carreras Callejeras', how: 'Gira ◀ ▶ para esquivar el tráfico y coger monedas. ¡Cada vez va más rápido!' },
      circus: { name: 'Malabares de Circo', how: 'Pulsa ◀ o ▶ cuando una pelota llegue a esa mano para volver a lanzarla.' },
      minesweeper: { name: 'Huerto de Topos', how: 'Toca para cavar. Los números cuentan los topos escondidos cerca. Usa el modo 🚩 para marcarlos.' },
      snake: { name: 'Oruga Glotona', how: 'Muévete con las flechas o deslizando. Come hojas para crecer, ¡pero no te muerdas!' },
      baseball: { name: 'Jonrón a Tope', how: 'Pulsa ● para batear cuando la pelota llegue a la base. ¡Si lo clavas, jonrón!' },
      maze: { name: 'Jardín de Luciérnagas', how: 'Vuela por el laberinto de setos recogiendo luz. ¡Las flores brillantes duermen a las ranas!' },
      match3: { name: 'Lío de Frutas', how: 'Intercambia dos frutas vecinas para juntar 3 o más en línea. ¡25 movimientos!' },
      puzzle: { name: 'Puzle Deslizante', how: 'Ordena las fichas del 1 al 8.' },
      blocks: { name: 'Torre de Bloques', how: 'Completa líneas con los bloques que caen.' },
      goldfish: { name: 'Pesca de Peces', how: 'Mete la red de papel bajo un pez y sácala. ¡Con suavidad o el papel se rompe! Dorado = 3.' },
      ringToss: { name: 'Lanzar Aros', how: 'Apunta con ◀ ▶, mantén ● (o la pantalla) y suelta con la fuerza justa. ¡10 aros!' },
      claw: { name: 'Máquina de Gancho', how: 'Mueve el gancho ◀ ▶ (o arrastra), pulsa ● para bajarlo y lleva un peluche a la salida. ¡5 partidas!' },
      dragonBoat: { name: 'Regata del Dragón', how: 'Pulsa ◀ ▶ por turnos al ritmo del tambor para remar. En la meta, ¡pulsa ● para coger la bandera!' },
      stoneStack: { name: 'Torre de Piedras', how: 'Toca para soltar la piedra que se balancea sobre la torre. ¡Mantén el equilibrio y ojo con el viento!' },
    },
    drawing: {
      prompt: 'La idea de hoy:',
      prompts: ['un gato', 'tu familia', 'un cerezo', 'la casa de tus sueños', 'un día de lluvia', 'tu mejor amigo', 'un monstruo'],
      clear: '🗑️',
      eraser: '🧽',
      share: '📤 Compartir en PixelBook',
      shared: '¡Compartido! A tus amigos les encanta.',
    },
    mines: { dig: '⛏️ Cavar', flag: '🚩 Marcar', left: (n: number) => `🐹 quedan ${n}` },
  },
};
